/** Bodyworks Miami — Calendly event URLs (inline embed) */
export const CALENDLY_ONLINE = 'https://calendly.com/bodyworksmiami/online-training';
export const CALENDLY_MOBILE = 'https://calendly.com/bodyworksmiami/mobile-training';
export const CALENDLY_GROUP_CLASS = 'https://calendly.com/bodyworksmiami/group-class';
export const CALENDLY_DEFAULT = 'https://calendly.com/bodyworksmiami/60minutes';

/**
 * Calendly embed colors (hex without #) — passed to initInlineWidget and URL query for iframe.
 * @see https://help.calendly.com/hc/en-us/articles/223147027-Embed-options-overview
 */
export const CALENDLY_EMBED_THEME = {
  background_color: '121212',
  text_color: 'f5f5f5',
  primary_color: 'ff4d00',
};

/** Booking URL with theme query params so the iframe loads with the right chrome. */
export function calendlyUrlWithTheme(calendlyUrl) {
  if (!calendlyUrl || typeof calendlyUrl !== 'string') return calendlyUrl;
  try {
    const u = new URL(calendlyUrl.trim());
    if (!u.hostname.includes('calendly.com')) return calendlyUrl.trim();
    const { background_color, text_color, primary_color } = CALENDLY_EMBED_THEME;
    if (!u.searchParams.has('background_color')) u.searchParams.set('background_color', background_color);
    if (!u.searchParams.has('text_color')) u.searchParams.set('text_color', text_color);
    if (!u.searchParams.has('primary_color')) u.searchParams.set('primary_color', primary_color);
    return u.toString();
  } catch {
    return calendlyUrl.trim();
  }
}

const EMBED_DOMAIN_FALLBACK = 'bodyworks-training.web.app';

/** Full-height iframe src for the booking modal (avoids undersized inline widget iframe). */
export function calendlyIframeSrc(calendlyUrl) {
  const themed = calendlyUrlWithTheme(calendlyUrl);
  try {
    const u = new URL(themed);
    if (!u.hostname.includes('calendly.com')) return themed;
    const host =
      typeof window !== 'undefined' && window.location?.hostname
        ? window.location.hostname
        : EMBED_DOMAIN_FALLBACK;
    if (!u.searchParams.has('embed_domain')) u.searchParams.set('embed_domain', host);
    if (!u.searchParams.has('embed_type')) u.searchParams.set('embed_type', 'Inline');
    return u.toString();
  } catch {
    return themed;
  }
}
